import React from 'react';
import Wrp from '../../../../hoc/Wrp/Wrp';
import {fileNameShortenForDisplay,parameterizedURLAccessToken} from '../../../../Utils/CommonFunctions';
import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const imageDetails = (props) => {
	return (
    <div className="imageListPdf">
      <div className="form-group">
        <label className="position-relative d-flex">
            Image Upload  
          <input accept="image/*" ref={props.uploadMultipleFiles} type="file" multiple style={{display:'none'}} onChange={props.uploadFilesHandler}/>
          <div className="cursor-pointer icon-right "> 
            <i className="fas fa-upload fa-lg" data-tip="Upload Image"></i> 
          </div>
        </label>
        <div className="imageForPdf" >

          <div className="noImageList op-3" style={{"display":"none"}}>

            <div className="last_light_color text-center"> <i className="far fa-image fa-lg"></i> <p className="text-small"> No File added </p></div>
          </div>
          {
            props.imageData.data ?
              props.imageData.data.length > 0 ?
                props.imageData.data.map((arr,i) => {
                  let copyText = arr.id;
                  if(props.copyPrefix!==undefined && props.copySuffix!==undefined){
                    copyText = props.copyPrefix+copyText+props.copySuffix;
                  }
                  let imagePath = '/assets/img/noimage.png';
                  if(arr.file && arr.file.type){
                    imagePath = URL.createObjectURL(arr.file);
                  }else if(arr.id !== ''){
                    imagePath = parameterizedURLAccessToken('files/download?fileId='+arr.id);
                  }
                  return (
                    <div key={i} className="YesImageList p-1">
                      <div className="d-flex">
                        <div className="avatar avatar-md">
                           <img src={imagePath} className="shadow avatar-img rounded-circle" /> 
                        </div>
                        <div className="ml-2 pt-1 ">
                          <h6 className="w-px-100 text-truncate  text-small"> {arr.id} </h6>
                          <CopyToClipboard text={ copyText }>
                            <i className="fas fa-copy fa-lg text-warning mr-1 cursor-pointer" data-tip="Copy"></i>
                          </CopyToClipboard>

                          <span className="text-muted cursor-pointer" onClick={e=>props.insertTextHandler(arr.id, 'img')}>
                            <i className="fas fa-file-import fa-lg text-warning cursor-pointer" data-tip="Insert"></i>
                          </span>
                          <small className="float-right text-muted cursor-pointer" onClick={e=>props.deleteUploadFiles(i)}>
                            <i className="far fa-trash-alt fa-lg  text-danger"></i>
                          </small>
                        </div>
                      </div>
                      <div className="separator-dashed m-1"></div>
                      <ToolTipWrapper />
                    </div>
                  )
                })
              : null
            : null
          }
        </div>
      </div>
      <ToolTipWrapper />
    </div>
	);
}

export default imageDetails;